import { Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { ProgressDots } from '@/components/DataDisplay/Indicator/ProgressDots';
import { Page } from '@/components/Layout/Page/Page';
import { OnboardingGuide } from '@/components/OnboardingGuide';

import { ROUTE } from '@/constants/routes';

import { useResponsive } from '@/hooks/useResponsive';
import { useTranslate } from '@/hooks/useTranslate';

import { ClientType } from '@/types/user';

import { getProgressSteps } from '@/utils/progressSteps';
import { censorEmail } from '@/utils/string';

import { ActivateAccountStepsConfig } from './components/ActivateAccountSteps';
import { VerifyEmailOtpForm } from './components/VerifyEmailOtpForm';

import {
  EmailOTPDescription,
  EmailOTPTitle,
  EmailOTPTitleHighlight,
} from './VeirifyOTPPage.styled';

export function VerifyOTPPage() {
  const { language } = useTranslate();
  const theme = useTheme();
  const { state } = useLocation();
  const { form } = state ?? {};
  const navigate = useNavigate();
  const [isPendingProfile, setPendingProfile] = useState(false);
  const { isDesktop, isMobile } = useResponsive();

  useEffect(() => {
    if (!form) {
      navigate(ROUTE.HOME, { replace: true });
    }
  }, [form, navigate]);

  if (!form) return null;

  const progressSteps = getProgressSteps(ClientType.MobileAdoption);
  return (
    <Page
      paperProps={{
        color: (theme: Theme) => theme.palette.neutral[1000],
        position: 'right',
        size: 'big',
        children: isMobile ? null : (
          <OnboardingGuide config={ActivateAccountStepsConfig} />
        ),
      }}
      hasLogo
      progressProps={progressSteps.emailOtpStep}
      showPendingApproval={isPendingProfile}
      hasBackToLoginButton={isDesktop}
      headerMobile={{
        centerSlot: <ProgressDots {...progressSteps.emailOtpStep} />,
        bgColor: (theme: Theme) => theme.palette.background.paper,
      }}
    >
      <VerifyEmailOtpForm
        countryForm={form}
        onPendingProfileChange={setPendingProfile}
      >
        <EmailOTPTitle>
          <Trans
            i18nKey="mobileAdoption.verifyOTP.title"
            lang={language}
            components={{ a1: <EmailOTPTitleHighlight as="span" /> }}
          />
        </EmailOTPTitle>
        <EmailOTPDescription>
          <Trans
            lang={language}
            i18nKey="mobileAdoption.verifyOTP.enterCode"
            values={{ email: censorEmail(form?.email || '') }}
            components={{
              br: <br />,
              email: (
                <Typography
                  variant="body1Bold"
                  color={theme.palette.text.primary}
                  component="span"
                />
              ),
            }}
          />
        </EmailOTPDescription>
      </VerifyEmailOtpForm>
    </Page>
  );
}

export default VerifyOTPPage;
